import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { Title, TitleConfig, TypographyConfig } from '@vds-core/typography';
import { Line } from '@vds-core/lines';
import { withVDSManager } from '@vds-core/utilities';

function _calculateAccentSpacing(size, viewport) {
  var accentSpacing;
  size === 'large' || viewport === 'desktop' || viewport === 'tablet' ? accentSpacing = calculateRem(6) : accentSpacing = calculateRem(2);
  return accentSpacing;
}

var propTypes = {
  /**
   * Represents the text in TitleAccented.
   */
  children: PropTypes.node.isRequired,

  /**
   * @deprecated
   */
  size: PropTypes.oneOf(['small', 'large']),
  // DEPRECATED

  /**
   * Primitive used for the component.
   */
  primitive: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),

  /**
   * Represents the size of the accent bar in TitleAccented. Desktop and tablet are the same size.
   */
  viewport: PropTypes.oneOf(['mobile', 'tablet', 'desktop']),

  /**
   * @ignore
   */
  calculateAccentSpacing: PropTypes.func,
  //this function takes size and viewport and returns a value used for spacing between text and line.

  /**
   * @ignore
   */
  titleConfig: PropTypes.object,

  /**
   * @ignore
   */
  typescale: PropTypes.string,

  /**
   * @ignore
   */
  tabIndex: PropTypes.number,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string
};
var defaultProps = {
  children: null,
  titleConfig: TitleConfig,
  typescale: TypographyConfig.getTypescale(),
  calculateAccentSpacing: _calculateAccentSpacing,
  // size: 'large',  DEPRECATED
  primitive: 'h3',
  viewport: 'desktop'
};
var StyledContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledContainer",
  componentId: "sc-1dyw5cn-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  &:active,\n  &:focus,\n  &:hover {\n    outline: none;\n  }\n  d * {\n    &:active,\n    &:focus,\n    &:hover {\n      outline: none;\n    }\n  }\n"])));
var LineWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "LineWrapper",
  componentId: "sc-1dyw5cn-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n\n  width: ", ";\n"])), function (_ref) {
  var size = _ref.size,
      viewport = _ref.viewport,
      calculateAccentSpacing = _ref.calculateAccentSpacing;
  return calculateAccentSpacing(size, viewport);
}, function (_ref2) {
  var size = _ref2.size,
      viewport = _ref2.viewport;
  return size === 'large' || viewport === 'desktop' || viewport === 'tablet' ? "".concat(calculateRem(48)) : "".concat(calculateRem(36));
});

var TitleAccented = function TitleAccented(_ref3) {
  var children = _ref3.children,
      size = _ref3.size,
      viewport = _ref3.viewport,
      primitive = _ref3.primitive,
      titleConfig = _ref3.titleConfig,
      calculateAccentSpacing = _ref3.calculateAccentSpacing,
      typescale = _ref3.typescale,
      tabIndex = _ref3.tabIndex,
      className = _ref3.className,
      id = _ref3.id;

  function _blurElem(e) {
    if (e.type === 'click') e.target.blur();
  }

  return /*#__PURE__*/React.createElement(StyledContainer, {
    id: id,
    className: className,
    onClick: _blurElem,
    tabIndex: tabIndex,
    "aria-label": children,
    role: "heading",
    size: size,
    viewport: viewport
  }, /*#__PURE__*/React.createElement(Title, {
    config: titleConfig,
    typescale: typescale,
    tabIndex: -1,
    onClick: _blurElem,
    children: children,
    primitive: primitive,
    viewport: size === 'large' || viewport === 'desktop' || viewport === 'tablet' ? 'desktop' : 'mobile',
    size: "large"
  }), /*#__PURE__*/React.createElement(LineWrapper, {
    size: size,
    viewport: viewport,
    calculateAccentSpacing: calculateAccentSpacing
  }, /*#__PURE__*/React.createElement(Line, {
    type: "accent",
    noMargin: true
  })));
};

export default withVDSManager(TitleAccented);
TitleAccented.propTypes = propTypes;
TitleAccented.defaultProps = defaultProps;